export class FsxSnapshotProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveryPointArn",
            "baseName": "recoveryPointArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "backupVaultName",
            "baseName": "backupVaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountId",
            "baseName": "sourceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeBackupArns",
            "baseName": "volumeBackupArns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "backedUpVolumes",
            "baseName": "backedUpVolumes",
            "type": "Array<FsxVolumeBackupInfo>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FsxSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
